import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { useSearchPageExactSearchReturnedNoResults } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageExactSearchReturnedNoResults";

export const useSearchPageShouldShowProductResults = () => {
  const exactSearchReturnedNoResults =
    useSearchPageExactSearchReturnedNoResults();
  const {
    data: { activeFilterCount },
  } = useFilterStore(["activeFilterCount"]);

  return activeFilterCount > 0 || !exactSearchReturnedNoResults;
};
